import { crypto } from "../crypto.js";
import { genevaParams } from "@local/extensions/fabrications/geneva";
import { nextFabMark } from "@local/extensions/identifiers/mark.js";
import { createNullFields } from "./makeup";
import type { PlainDimension } from "dimtext";

interface FabricationBase {
  id: string;
  mark: string;
  name: string;
  notes: string;
  position: "corner" | "edge" | "edge-aligned";
}

interface StaticFabrication extends FabricationBase {
  type: "static",
  path: object,
};

interface GenericFabrication extends FabricationBase {
  type: "generic",
  drawing?: string,
}

interface FunctionFabrication extends FabricationBase {
  type: "function",
  func: "geneva" | "patch" | "cutout"
  params: Array<PlainDimension>
}

interface OrgDefinedFabrication extends FabricationBase {
  type: "org-defined",
  product_id: string,
}

type Fabrication =
  | StaticFabrication
  | GenericFabrication
  | FunctionFabrication
  | OrgDefinedFabrication;


function createFabrication(fabrications = []) {
  const mark = nextFabMark(fabrications);
  const regex = /([0-9]+)$/;
  let name;
  if (mark.match(regex)) {
    const num = parseInt(mark.match(regex)[1], 10);
    name = `Fabrication ${num}`;
  } else {
    name = `Fabrication ${mark}`;
  }

  return {
    id: crypto.randomUUID(),
    mark,
    name,
    definition: "custom",
    product_id: null,
    type: "function",
    func: "geneva",
    position: "edge",
    notes: null,
    params: genevaParams.map((p) => p.default),
  };
}

function createFabricationProduct() {
  const data = {
    type: "generic",
    position: "edge",
    drawing: null,
  }

  return {
    ...createNullFields(),
    application: "fabrication",
    data,
  }
}

export { createFabrication, createFabricationProduct }
export type { Fabrication }
